@for (payment of payments; track payment) {
  <sd-payment class="payment" [payment]="payment" (removePayment)="removePayment.emit(payment)"></sd-payment>
}

<sd-add-payment class="add-payment" (click)="addPayment.emit()"></sd-add-payment>
